import { IMG } from "./site";

export const LOCATIONS = [
  {
    slug: "coventry",
    name: "Coventry",
    region: "Coventry & West Midlands",
    image: IMG.coventry,
    eta: "25–45 mins",
    postcodes: "CV postcodes",
    routes: "M6 · M69 · A45 · A46",
    districts: [
      "City Centre", "Foleshill", "Tile Hill", "Binley", "Canley",
      "Walsgrave", "Earlsdon", "Finham", "Keresley", "Radford",
      "Coundon", "Wyken",
    ],
    intro: [
      "From the ring road to the outer estates, our Coventry vans cover the whole city around the clock. Whether you're parked at home in Earlsdon, at work by the airport on the A45, or stranded on the M69 approach, a technician is rarely more than half an hour away.",
      "Coventry sits at the crossroads of the M6 and M69, and our teams know every junction, retail park and commuter belt around it — Bedworth and Nuneaton on the northern side, Kenilworth and Leamington approaches to the south. Send your location on WhatsApp and we'll confirm an exact ETA before the van even rolls.",
    ],
    faqs: [
      {
        q: "Do you cover the M6 around Coventry?",
        a: "Yes — we attend hard-shoulder and junction call-outs around the M6, M69 and A45/A46 corridors. On a motorway, always put your safety first and call us once you're in a safe place.",
      },
      {
        q: "Can you come to my workplace car park?",
        a: "Absolutely. We regularly fit at office parks, retail car parks and driveways across CV postcodes — just tell us where the car is.",
      },
      {
        q: "How fast is a Coventry call-out?",
        a: "Typical response is 25 to 45 minutes across the city, 24 hours a day.",
      },
    ],
  },
  {
    slug: "central-london",
    name: "Central London",
    region: "Central & Greater London",
    image: IMG.london,
    eta: "30–50 mins",
    postcodes: "All central zones",
    routes: "M25 · A40 · A4 · A3",
    districts: [
      "West End", "City of London", "Mayfair", "Kensington", "Chelsea",
      "Shoreditch", "Camden", "Waterloo", "Westminster", "Fulham",
      "Islington", "Docklands",
    ],
    intro: [
      "A flat tyre in London is a special kind of misery — and parking a van next to your car takes local knowledge. Our London teams handle tight streets, residents' bays, congestion-zone rules and underground car parks every single day, from Mayfair mews to Shoreditch office blocks.",
      "We cover the central zones and the greater sprawl along the A40, A4 and A3 corridors and inside the M25 ring. Whether your car is on a Kensington street at midnight or in a Canary Wharf bay at 7am, we dispatch the nearest van and work around your parking reality — that's the whole point of mobile fitting.",
    ],
    faqs: [
      {
        q: "Can you fit on a central London street?",
        a: "Yes. Street-side fitting is routine for us — we handle parking bays, permit streets and busy kerbs across all central zones every day.",
      },
      {
        q: "Do you cover underground car parks?",
        a: "In most cases yes, subject to height clearance for the van. Tell us the car park when you book and we'll bring the right approach.",
      },
      {
        q: "What about the congestion charge or ULEZ?",
        a: "Our vans are ULEZ compliant, and call-out access to central zones is part of the service — you won't get surprise surcharges after the job.",
      },
    ],
  },
  {
    slug: "reading",
    name: "Reading",
    region: "Reading & Berkshire",
    image: IMG.reading,
    eta: "25–40 mins",
    postcodes: "RG postcodes",
    routes: "M4 J10–12 · A33 · A329(M)",
    districts: [
      "Reading Centre", "Caversham", "Tilehurst", "Earley", "Woodley",
      "Theale", "Purley", "Calcot", "Lower Earley", "Sonning",
      "Winnersh", "Shinfield",
    ],
    intro: [
      "The M4 corridor runs on tyres — commuters, estates, and logistics all funnel through Reading's junctions. Our Berkshire teams cover the town centre, Caversham and the surrounding RG towns, with fast response along the A33 and A329(M) where most of the region's punctures seem to happen.",
      "We reach Bracknell, Wokingham, Theale and the villages in between with the same 25-to-40-minute window we promise in town. Home driveway fittings are the backbone of our Reading diary — perfect for busy commuter households who can't spare a morning at a garage.",
    ],
    faqs: [
      {
        q: "Do you cover Bracknell and Wokingham?",
        a: "Yes — the whole M4 corridor around Reading, including Bracknell, Wokingham, Slough approaches and the villages along the A4.",
      },
      {
        q: "I commute to London — can you fit at home in the evening?",
        a: "That's one of our most common Reading bookings. We're a 24/7 service, so evenings and early mornings are completely normal.",
      },
      {
        q: "How fast is a Reading call-out?",
        a: "Typically 25 to 40 minutes across the town and surrounding RG areas.",
      },
    ],
  },
  {
    slug: "bristol",
    name: "Bristol",
    region: "Bristol & South West",
    image: IMG.bristol,
    eta: "30–45 mins",
    postcodes: "BS postcodes",
    routes: "M4 · M5 · A38 · M32",
    districts: [
      "City Centre", "Clifton", "Filton", "Avonmouth", "Bedminster",
      "Bishopston", "Keynsham", "Portishead", "Horfield", "Knowle",
      "Emersons Green", "Bath approach",
    ],
    intro: [
      "Between the M4 and the M5, Bristol's roads throw everything at your tyres — steep hills, dockside roads and the M32 commute. Our South West teams cover the city from Clifton to Avonmouth and out through Keynsham and Portishead, day and night.",
      "Bristol's slopes make a flat tyre more than an inconvenience; it can be a real safety job. We bring the workshop to wherever you are — hillside streets in Bishopston, office parks in Filton, or the retail sprawl near Cribbs Causeway — and get you rolling with fitting, balancing and repair on the spot.",
    ],
    faqs: [
      {
        q: "Do you cover Bath?",
        a: "We cover the Bristol city region and the Bath approach corridor. Send your location on WhatsApp and we'll confirm the exact response time.",
      },
      {
        q: "Can you handle Bristol's steep residential streets?",
        a: "Yes — hillside and terrace-street fittings are routine for our Bristol teams. Tell us about access when you book.",
      },
      {
        q: "Which junctions do you cover?",
        a: "The whole M4/M5 interchange area, the M32 corridor and the A38 between them, plus every BS postcode district in between.",
      },
    ],
  },
  {
    slug: "cardiff",
    name: "Cardiff",
    region: "Cardiff & South Wales",
    image: IMG.cardiff,
    eta: "30–50 mins",
    postcodes: "CF postcodes",
    routes: "M4 J24–33 · A48 · A470",
    districts: [
      "Cardiff Bay", "City Centre", "Cathays", "Roath", "Pontprennau",
      "Llanishen", "Rhiwbina", "Penarth", "Barry", "Newport",
      "Caerphilly", "Rumney",
    ],
    intro: [
      "From the Bay to the Valleys' edge, our Cardiff teams run the M4 corridor between junctions 24 and 33 around the clock. City centre fittings, Penarth driveways, Barry seafront call-outs and Newport industrial parks are all in a normal day's diary.",
      "The A470 and M4 are two of the busiest roads in Wales, and punctures don't respect office hours. Whether you're commuting into the capital or doing the school run in Rhiwbina, we dispatch the nearest van with fitting, balancing and repair kit on board — typically within 30 to 50 minutes.",
    ],
    faqs: [
      {
        q: "Do you come to Newport?",
        a: "Yes — Newport and the eastern M4 corridor sit inside our South Wales coverage. Send your location for an exact ETA.",
      },
      {
        q: "Can you fit at Cardiff Bay apartments?",
        a: "We handle resident parking areas across the Bay regularly. Include any parking codes or access notes when you book on WhatsApp.",
      },
      {
        q: "Are you available weekends in Cardiff?",
        a: "We operate 24/7, weekends and bank holidays included. Weekends are peak time for call-outs, so booking early in the day gets the fastest slot.",
      },
    ],
  },
  {
    slug: "cambridge",
    name: "Cambridge",
    region: "Cambridge & Cambridgeshire",
    image: IMG.cambridge,
    eta: "30–45 mins",
    postcodes: "CB postcodes",
    routes: "M11 · A14 · A10",
    districts: [
      "City Centre", "Trumpington", "Girton", "Milton", "Cherry Hinton",
      "Arbury", "Addenbrooke's area", "Ely", "Huntingdon", "St Ives",
      "Sawston", "Waterbeach",
    ],
    intro: [
      "Cyclists aren't the only ones who suffer Cambridge's streets — the city's buses, bikes and building works are hard on tyres too. Our Cambridgeshire teams cover the city centre's tight lanes and the science park's car parks, with rapid response up the A10 and A14 to Ely, Huntingdon and St Ives.",
      "M11 commuter belt fittings are our Cambridge speciality: a tyre fitted at your driveway while you finish breakfast is a far better morning than one lost to a garage queue. We cover students, families and fleet drivers across the CB postcodes, 24 hours a day.",
    ],
    faqs: [
      {
        q: "Do you cover Ely and Huntingdon?",
        a: "Yes — up the A10 to Ely and the A14 corridor to Huntingdon and St Ives, with typical response of 30 to 45 minutes.",
      },
      {
        q: "Can you fit in Cambridge city centre's narrow streets?",
        a: "Yes, though some central lanes have restricted access. Tell us where the car is when you book and we'll confirm the best plan.",
      },
      {
        q: "Do you serve the science and business parks?",
        a: "Regularly — workplace fittings at the parks off the M11 and A14 are among our most common Cambridge bookings.",
      },
    ],
  },
  {
    slug: "northampton",
    name: "Northampton",
    region: "Northampton & Northamptonshire",
    image: IMG.northampton,
    eta: "30–45 mins",
    postcodes: "NN postcodes",
    routes: "M1 · A45 · A43",
    districts: [
      "Town Centre", "Duston", "Weston Favell", "Kingsthorpe", "Abington",
      "Upton", "Billing", "Wellingborough", "Kettering", "Rushden",
      "Daventry", "Towcester",
    ],
    intro: [
      "Northampton sits on the M1, and the county's roads never really stop — commuters streaming down to London, vans serving the logistics parks, families on the A45 between the towns. Our Northamptonshire teams cover the whole NN patch, from Weston Favell to Duston and out to Wellingborough, Kettering, Rushden and Daventry.",
      "Motorway call-outs on the M1 and driveway fittings across the county's market towns are both normal diary entries here. Send your location on WhatsApp and a technician with the right tyres loaded is dispatched — typically arriving within 30 to 45 minutes, any hour of the day or night.",
    ],
    faqs: [
      {
        q: "Do you cover Wellingborough and Kettering?",
        a: "Yes — the whole north-east corner of the county including Wellingborough, Kettering and Rushden, with typical response of 30 to 45 minutes.",
      },
      {
        q: "Can you attend M1 breakdowns?",
        a: "Yes. We attend M1 call-outs around the Northampton junctions regularly. For your safety, always get to a safe place and call us once you and your passengers are secure.",
      },
      {
        q: "Do you reach Daventry and Towcester?",
        a: "We do — Daventry, Towcester and the A45/A43 corridors sit inside our Northampton coverage. Send your location for an exact ETA.",
      },
    ],
  },
  {
    slug: "oxford",
    name: "Oxford",
    region: "Oxford & Oxfordshire",
    image: IMG.oxford,
    eta: "30–45 mins",
    postcodes: "OX postcodes",
    routes: "M40 · A34 · A40",
    districts: [
      "City Centre", "Cowley", "Headington", "Summertown", "Jericho",
      "Botley", "Blackbird Leys", "Kidlington", "Abingdon", "Bicester",
      "Didcot", "Witney",
    ],
    intro: [
      "Oxford's streets are beautiful and famously tight — and a flat tyre in a listed lane is nobody's idea of a good afternoon. Our Oxford teams know exactly how to work in the city's narrow lanes and full car parks, and just as comfortably in the driveways of Headington, Cowley and Summertown.",
      "The A34 and M40 corridors funnel thousands of cars through Oxfordshire daily, and we cover the satellites too: Abingdon, Bicester, Didcot, Witney and Kidlington. Whether you're a commuter caught on the A34 or a household that wants new tyres fitted without losing a Saturday, we come to you — 24 hours a day.",
    ],
    faqs: [
      {
        q: "Can you fit tyres in Oxford's narrow central streets?",
        a: "Yes — restricted lanes are routine for us. Tell us where the car is parked when you book and we'll confirm access and the best approach.",
      },
      {
        q: "Do you cover the A34 and M40?",
        a: "Yes, including call-outs along the A34 corridor and M40 junctions around Oxford. Always stop somewhere safe first and call us from there.",
      },
      {
        q: "What about Didcot, Bicester and Witney?",
        a: "All covered, with typical response of 30 to 45 minutes across the OX patch.",
      },
    ],
  },
  {
    slug: "southampton",
    name: "Southampton",
    region: "Southampton & South Coast",
    image: IMG.southampton,
    eta: "30–45 mins",
    postcodes: "SO postcodes",
    routes: "M27 · M3 · A33",
    districts: [
      "City Centre", "Portswood", "Bitterne", "Shirley", "Woolston",
      "Hedge End", "Eastleigh", "Totton", "Fareham", "Gosport",
      "Hythe", "Winchester approach",
    ],
    intro: [
      "A working port city runs around the clock, and so do we. From the docks and the Itchen bridges to Shirley, Bitterne and Portswood, our Southampton teams cover the city and the M27/M3 crossroads that carry its traffic — night shift or morning school run, the van comes to you.",
      "We reach east across to Fareham and Gosport, north to Eastleigh and Winchester's approaches, and west into Totton and the edge of the New Forest. Fitting, balancing, puncture repair and alignment all happen at your location — a full workshop on wheels, on the South Coast.",
    ],
    faqs: [
      {
        q: "Do you cover Fareham and Gosport?",
        a: "Yes — the M27 corridor east of the city including Fareham and Gosport, with typical response of 30 to 45 minutes.",
      },
      {
        q: "Can you come out for the docks or cruise terminal?",
        a: "We regularly attend vehicle parks and streets around the port area. Tell us the site and any pass requirements when you book on WhatsApp.",
      },
      {
        q: "Do you reach the New Forest edge?",
        a: "We cover Totton, Hythe and the Forest's northern edges. Forest roads are hard on tyres — save our number before you need it.",
      },
    ],
  },
  {
    slug: "bournemouth",
    name: "Bournemouth",
    region: "Bournemouth & Dorset",
    image: IMG.bournemouth,
    eta: "30–50 mins",
    postcodes: "BH postcodes",
    routes: "A338 · A31 · M27",
    districts: [
      "Town Centre", "Boscombe", "Southbourne", "Westbourne", "Winton",
      "Kinson", "Wallisdown", "Poole", "Christchurch", "Ferndown",
      "Ringwood", "Ashley Heath",
    ],
    intro: [
      "From the pier to Poole and along to Christchurch, the conurbation stretches for miles — and its roads stretch your tyres. Our Dorset teams cover the whole BH patch: the A338 into town, the A31 out to Ringwood and Ferndown, and every residential street in between.",
      "Summer traffic and coastal roads keep our Bournemouth vans busy, so we run them 24/7 with full fitting, balancing and repair kit on board. Whether you're a local, a seasonal worker or you've just arrived for the beach weekend, a flat tyre costs you minutes, not your day.",
    ],
    faqs: [
      {
        q: "Do you cover Poole and Christchurch?",
        a: "Yes — the full conurbation from Poole through Bournemouth to Christchurch, plus Ferndown and Ringwood on the A31 side.",
      },
      {
        q: "How does summer traffic affect response?",
        a: "Peak summer weekends can add a few minutes to the ETA, especially around the beachfront. We'll always give you an honest time when you call.",
      },
      {
        q: "Can you fit at beach car parks or holiday lets?",
        a: "Yes — guest houses, holiday lets and seafront car parks are routine call-outs. Send your location on WhatsApp and we'll find you.",
      },
    ],
  },
  {
    slug: "bath",
    name: "Bath",
    region: "Bath & North East Somerset",
    image: IMG.bath,
    eta: "30–45 mins",
    postcodes: "BA postcodes",
    routes: "A36 · A46 · M4 (J18)",
    districts: [
      "City Centre", "Oldfield Park", "Twerton", "Combe Down", "Bathwick",
      "Larkhall", "Newbridge", "Keynsham", "Radstock", "Trowbridge",
      "Chippenham", "Corsham",
    ],
    intro: [
      "Bath's hills are glorious to look at and unforgiving to break down on. Our teams cover the crescents and terraces of the city — Oldfield Park, Combe Down, Bathwick, Larkhall — and the surrounding towns: Keynsham, Radstock, and across the Wiltshire line to Trowbridge, Chippenham and Corsham.",
      "We handle the narrow Georgian streets, the steep hillsides and the A36/A46 corridors that connect Bath to the M4. Puncture repairs, new tyres and alignment are all done at your door — no rolling the car down a hill to a garage required.",
    ],
    faqs: [
      {
        q: "Can you handle Bath's steep residential streets?",
        a: "Yes — hillside fittings across Combe Down, Larkhall and the terraces are routine. Mention any access quirks when you book so we come prepared.",
      },
      {
        q: "Do you cover Trowbridge and Chippenham?",
        a: "Yes — the wider BA patch including Trowbridge, Chippenham, Corsham, Keynsham and Radstock, typically within 30 to 45 minutes.",
      },
      {
        q: "Are you able to attend the A36 or A46?",
        a: "We do, including the M4 junction 18 approaches. Get somewhere safe first, then call or WhatsApp us your location.",
      },
    ],
  },
  {
    slug: "peterborough",
    name: "Peterborough",
    region: "Peterborough & Fenland",
    image: IMG.peterborough,
    eta: "30–45 mins",
    postcodes: "PE postcodes",
    routes: "A1(M) · A47 · A15",
    districts: [
      "City Centre", "Bretton", "Orton", "Hampton", "Werrington",
      "Stanground", "Paston", "Yaxley", "Whittlesey", "Sawtry",
      "March", "Stamford approach",
    ],
    intro: [
      "Peterborough is an A1(M) city — high-speed roads on one side, fen roads on the other, and both are hard on tyres. Our teams cover the city's townships from Bretton to Hampton and Stanground, and out along the A47 and A15 to Whittlesey, Yaxley, Sawtry and the fen edge beyond.",
      "The straight, windswept fen roads hide their fair share of potholes and debris, and a puncture out there can leave you very exposed. We run the patch 24/7 with full fitting, balancing and repair kit on board — typically 30 to 45 minutes to any Peterborough postcode, however rural it looks.",
    ],
    faqs: [
      {
        q: "Do you cover the fen villages?",
        a: "Yes — Whittlesey, Yaxley, Sawtry, March and the roads between them all sit inside our Peterborough coverage.",
      },
      {
        q: "Can you attend A1(M) breakdowns?",
        a: "Yes, along the A1(M) and the A47/A15 corridors. Please reach a safe place first — then call us and we'll dispatch the nearest van.",
      },
      {
        q: "Do you reach Stamford?",
        a: "We cover the Stamford approach roads from the west of the city. Send your location on WhatsApp and we'll confirm your exact ETA.",
      },
    ],
  },
];

export const getLocation = (slug) => LOCATIONS.find((l) => l.slug === slug);
